$.ready(function() {
	game.dimensions.width  = 1920;
	game.dimensions.height = 1080;
	
	game.panel.buildHelp(8);
	
	/* globals base spinDone */
	game.sounds.loadSounds({
		_base: base,
		konami_bell: require('../sounds/FeatureTrigger.mp3'),
		bell: require('../sounds/FeatureTrigger.mp3'),
		trigger: require('../sounds/bell.mp3'),
		drop: {
			'0': [ null, null, null, null, null ],
			'11': [require('../sounds/drop/11/ScatterOrchHit01.mp3'), require('../sounds/drop/11/ScatterOrchHit02.mp3'),require('../sounds/drop/11/ScatterOrchHit03.mp3'),require('../sounds/drop/11/ScatterOrchHit04.mp3'),require('../sounds/drop/11/ScatterOrchHit05.mp3') ],
			'DASS': [require('../sounds/drop/DASS/DASS01.mp3'), require('../sounds/drop/DASS/DASS02.mp3'),require('../sounds/drop/DASS/DASS03.mp3'),require('../sounds/drop/DASS/DASS04.mp3'),require('../sounds/drop/DASS/DASS05.mp3') ],
		},
		reel: [ require('../sounds/reel/reel.mp3'), require('../sounds/reel/reel.mp3'), require('../sounds/reel/reel.mp3'), require('../sounds/reel/reel.mp3'), require('../sounds/reel/reel.mp3') ],
		reel_start: require('../sounds/reel_start.mp3'),
		reel_stop: require('../sounds/reel_stop.mp3'),
		anticipate: {
			11: require('../sounds/anticipate/LongerSpin.mp3'),
		},
		multi_sweep: require('../sounds/MultiSweep.mp3'),
		multi_sweep_twinkle: require('../sounds/MultiSweepBell.mp3'),
		buttons: {
			denoms: {
				denom_0: require('../sounds/buttons/denoms/denom-12.mp3'),
				denom_1: require('../sounds/buttons/denoms/denom-11.mp3'),
				denom_2: require('../sounds/buttons/denoms/denom-10.mp3'),
				denom_3: require('../sounds/buttons/denoms/denom-9.mp3'),
				denom_4: require('../sounds/buttons/denoms/denom-8.mp3'),
				denom_5: require('../sounds/buttons/denoms/denom-7.mp3'),
				denom_6: require('../sounds/buttons/denoms/denom-6.mp3'),
			},
			coins: {
				bet_0: require('../sounds/buttons/coins/bet-3.mp3'),
				bet_1: require('../sounds/buttons/coins/bet-2.mp3'),
				bet_2: require('../sounds/buttons/coins/bet-1.mp3'),
				bet_3: require('../sounds/buttons/coins/bet.mp3'),
				bet_4: require('../sounds/buttons/coins/bet+1.mp3'),
				bet_5: require('../sounds/buttons/coins/bet+2.mp3'),
				bet_6: require('../sounds/buttons/coins/bet+3.mp3'),
				bet_7: require('../sounds/buttons/coins/bet+4.mp3'),
				bet_8: require('../sounds/buttons/coins/bet+5.mp3'),
			},
			max: require('../sounds/buttons/max_bet.mp3'),
			sound: require('../sounds/buttons/volume.mp3'),
			help: require('../sounds/buttons/open.mp3'),
			close: require('../sounds/buttons/close.mp3'),
			next: require('../sounds/buttons/next.mp3'),
			prev: require('../sounds/buttons/prev.mp3'),
		},
		freespin: {
			// default intro sound has bad timing for this title, used in freespin init
			background: require('../sounds/freespin/BgmFg.mp3'),
			waiting: require('../sounds/freespin/Waiting.mp3'),
			smallTrigger: require('../sounds/freespin/FeatureTriggerShort.mp3'),
			countUp: require('../sounds/freespin/FreeGameCountUp.mp3'),
		},
		latch: require('../sounds/latch.mp3'),
		reveal: require('../sounds/Reveal.mp3'),
		win: {
			// decor : require('../sounds/decor.mp3'),
			intro1: require('../sounds/win/intro1.mp3'),
			intro2: require('../sounds/win/intro2.mp3'),
			win_1: require('../sounds/win/Level1_Hit01s.mp3'),
			win_2: require('../sounds/win/Level2_Hit06s.mp3'),
			win_3: require('../sounds/win/Level3_Hit10s.mp3'),
			bigwin_1: require('../sounds/win/Level4_Hit12s.mp3'),
			bigwin_2: require('../sounds/win/Level5_Hit17s.mp3'),
			bigwin_3: require('../sounds/win/Level6_Hit24s.mp3'),
		},
	});
	
	game.pays.forceCycles = true;
	game.pays.time = 2000;
	
	var reels = $.div('reels');
	reels.prependTo(game.container);
		
	var actionLogo = $.div('action-logo');
	actionLogo.appendTo(game.container);
	
	var xtraReward = $.div('xtra-reward');
	xtraReward.appendTo(game.container);
	
	game.fire_holder = $.div('fireworks').appendTo(game.container);
	game.cel_holder = $.div().addClass('div-crop').appendTo(game.fire_holder);
	game.celebration = $.div('celebration').addClass('').appendTo(game.cel_holder);
		
	var freespin = game.features.freespin = game.generateFreespin({ symbol: 11, introTime: 6500, noAutomatedSounds: true, outroTime: 1, triggerTime: 5000 });
	
	freespin.dimensions = {
		width:	1920,
		height: 1222,
		font: 32,
	};
	
	var bubbles = 0;
	var recallFinish = false;
	
	game.panel.dialog.pager.bubbles.on('click', function() {
		if (bubbles > game.panel.dialog._page) {
			game.sounds.play([ 'buttons', 'prev' ]);
			bubbles = game.panel.dialog._page;
		}
		else if (bubbles < game.panel.dialog._page) {
			game.sounds.play([ 'buttons', 'next' ]);
			bubbles = game.panel.dialog._page;
		}
	});
	
	// Help screen close
	game.panel.dialog.pager.exit.on('click', function() {
		game.sounds.play([ 'buttons', 'close' ]);
		bubbles = 0;
	});
	
	// Help screen right arrow click
	game.panel.dialog.pager.right.on('click', function() {
		game.sounds.play([ 'buttons', 'next' ]);
		bubbles = game.panel.dialog._page;
	});
	
	// Help screen left arrow click
	game.panel.dialog.pager.left.on('click', function() {
		game.sounds.play([ 'buttons', 'prev' ]);
		bubbles = game.panel.dialog._page;
	});
	
	game.on('scale', function() {
		for (var row in game.frame.reels) {
			animationResize(game.frame.reels[row].tall);
			animationResize(game.frame.reels[row].tall.inner);
		}
	});
	
	var animationResize = function(animation) {
		animation.css('width', null);
		animation.css('width', animation.el.offsetWidth);
	};
	
	game.on('ui', function(e) {
		game.feature.cost = e.detail.xtra_reward.cost;
		
		if (!e.detail.recall) {
			return;
		}
		
		for (var recallAction in e.detail.recall.actions) {
			var type = e.detail.recall.actions[recallAction].response;
			
			if (type.action === 'finish') {
				recallFinish = true;
			}
		}
	});
	
	game.on('bet', function(e) {
		e.detail.feature_cost = game.feature.cost;
	});
	
	game.on('recall_action', function(e) {
		var response = e.detail.action.response;
		
		if (!response.matrix) {
			return;
		}
		
		setWilds(response.matrix);
	});
	
	game.on('ready', function() {
		// Default bell timing is not right for this title, plays on freespin init
		setTimeout(function() {
			if (!game.sounds.fallback) {
				game.sounds.sounds.bell = null;
			}
		}, 15);
		
		if (!game.last.matrix || game.feature.active) {
			return;
		}
		
		// if (recallFinish) {
		// 	game.last.recovered = true;
		// 	game.last.doubleRollup = false;
		// }
		
		setWilds();
		recoverReplaced();
		
		for (var row in game.last.matrix) {
			for (var symbol in game.last.matrix[row]) {
				if (game.last.matrix[row][symbol] === 0) {
					game.frame.reels[row].tall.addClass('wild');
					game.frame.reels[row].tall.addClass(game.spindle.reels[row].window.tall.pos);
					animationResize(game.frame.reels[row].tall);
					animationResize(game.frame.reels[row].tall.inner);
				}
			}
		}
	});
	
	game.spindle.on('spin', function() {
		for (var row in game.frame.reels) {
			game.frame.reels[row].tall.attr('class', '');
			game.spindle.reels[row].window.tall.addClass('show');
		}
	});

	game.on('spin_init', function(e) {
		var replaceCount = 0;
		var sounds = game.sounds.fallback ? game.sounds.fallback : game.sounds.sounds;
		
		// REPLACE FEATURE
		this.spindle.attr('class', 's' + this.last.replace);
		
		for (var row in game.last.replaced) {
			sounds.reel[row] = sounds.reel_stop;
			
			for (var symbol in game.last.replaced[row]) {
				if (game.last.replaced[row][symbol]) {
					if (game.spindle.stop === -1) {
						break;
					}
					
					if (row === '4' && replaceCount < 2) {
						break;
					}
					
					else if (row === '3' && replaceCount === 0) {
						break;
					}
					
					sounds.reel[row] = sounds.drop.DASS[replaceCount];
					replaceCount++;
					break;
				}
			}
		}
		
		game.messaging.show('logo');
	});
	
	game.on('reel_init', function(e) {
		var reels = e.detail.reels;
		var counter = 0;
		
		for (var row in reels) {
			for (var symbol in reels[row]) {
				if ( reels[row][symbol] !== 0) {
					continue;
				}
				
				if (!counter) {
					reels[row][symbol] = '0_t';
					counter++;
				}
				
				else if (counter === 1) {
					reels[row][symbol] = '0_m';
					counter++;
				}
				
				else {
					reels[row][symbol] = '0_b';
					counter = 0;
				}
			}
		}
	});
		
	game.on('spin_ready', function(e) {
		game.pays.time = 2000;
		game.last.bothComplete = false;
		game.removeClass('quick-blink');
		
		if (game.last.doubleRollup) {
			game.last.totalWin = game.last.win;
			game.last.win = game.last.baseWin;
			game.pays.time = 750;
			game.addClass('quick-blink');
		}
		
		if (game.last.bonuses) {
			game.last.delayBonuses = game.last.bonuses[0];
			game.last.bonuses = undefined;
		}
		
		setWilds();
		
		if (game.last.replaced) {
			for ( var row in game.last.replaced) {
				for ( var symbol in game.last.replaced[row]) {
					if (game.last.replaced[row][symbol]) {
						game.spindle.reels[row].window.symbols[symbol].addClass('replaced');
						game.frame.reels[row].symbols[symbol].addClass('replaced');
					}
				}
			}
		}
		
		if (game.last.bonuses && game.last.bonuses.length) {
			game.last.delayBonus = true;
		}
	});
	
	game.on('spin_pre_done', function() {
		for (var row in game.spindle.reels) {
			if (game.spindle.reels[row].window.tall.hasClass('show')) {
				game.frame.reels[row].tall.attr('class', 'wild ' + game.spindle.reels[row].window.tall.pos + ' quick');
				game.spindle.reels[row].window.tall.attr('class', '');
				
				animationResize(game.frame.reels[row].tall);
				animationResize(game.frame.reels[row].tall.inner);
			}
		}
		if (game.last.doubleRollup && game.last.baseWin) {
			setTimeout(function() {
				frameFlash();
			}, 500);
		}
		
		if (game.last.lines && game.last.lines.pays.length === 0) {
			setTimeout(function() {
				if (game.last.doubleRollup) {
					game.last.bothComplete = true;
					beginDass();
				}
			}, 1000);
		}
		
		if (game.last.spindleReal) {
			game.spindle.reels[game.last.stackedReel].real = game.last.spindleReal;
		}
		
		decideFireworks();
	});
	
	game.on('round_complete', function() {
		for (var row in game.frame.reels) {
			if (game.frame.reels[row].tall.hasClass('wild')) {
				game.spindle.reels[row].window.tall.attr('class', game.spindle.reels[row].window.tall.pos);
			}
		}
		
		game.fire_holder.removeClass('animate');
		game.celebration.removeClass('animate');
	});
	
	game.pays.on('update', function(e) {
		var curSym = null;
		var line = e.detail.line - 1;
		
		if (line === game.pays.list[0].line && game.last.doubleRollup) {
			if (!game.last.payCycle) {
				game.last.payCycle = true;
			}
			
			else {
				beginDass();
			}
		}
		
		for (var row in game.frame.reels) {
			for (var symbol in game.frame.reels[row].symbols) {
				curSym = game.frame.reels[row].symbols[symbol];
				
				if (curSym.hasClass('win')) {
					game.frame.reels[row].tall.addClass('win');
					animationResize(game.frame.reels[row].tall);
					animationResize(game.frame.reels[row].tall.inner);
					break;
				}
				
				else {
					game.frame.reels[row].tall.removeClass('win');
				}
			}
		}
	});
	
	game.on('slamPays', function() {
		if (!game.last.doubleRollup || game.last.dassTriggered ) {
			return;
		}
		
		game.last.bothComplete = true;
		beginDass();
	});
	
	game.panel.win.on('done', function() {
		var validDass = (game.last.doubleRollup && !game.last.dassTriggered);
		
		if (game.last.spins_aquired && !game.features.freespin.inited) {
			game.sounds.play([ 'freespin', 'waiting' ], true);
		}
		
		if (validDass) {
			beginDass();
		}
		
		else if (!game.feature.active && game.autoplay.isActive() && validDass) {
			beginDass();
		}
	});
	
	game.features.freespin.on('init', function() {
		game.features.freespin.intro.appendTo(game.container);
	});
	
	game.features.freespin.on('spin', function() {
		game.last.spindleReal = game.spindle.reels[game.last.stackedReel].real;
		game.spindle.reels[game.last.stackedReel].real = [ -1 ];
		game.spindle.reels[game.last.stackedReel].real.index = 0;
		game.spindle.reels[game.last.stackedReel].update();
	});
	
	game.features.freespin.on('play', function() {
		if (!game.last.spins_aquired) {
			return;
		}
		game.celebration.removeClass('animate');
		game.fire_holder.removeClass('animate');
		
		game.addClass('switchBackground');
		game.sounds.stop([ 'freespin', 'waiting' ]);
		
		if (!game.sounds.fallback) {
			game.sounds.play([ 'freespin', 'background' ], true);
		}
	});
	
	game.features.freespin.on('finish', function() {
		game.removeClass('switchBackground');
		
		for (var row in game.frame.reels) {
			game.frame.reels[row].tall.attr('class', '');
			game.spindle.reels[row].window.tall.attr('class', '');
		}
		
		if (game.inRecall) {
			return;
		}

		setTimeout(function() {
			for (var row in game.old.matrix) {
				for (var symbol in game.old.matrix[row]) {
					if (game.old.replaced[row][symbol]) {
						game.frame.reels[row].tall.attr('class', 'scatterRepeat full animate quick');
						animationResize(game.frame.reels[row].tall);
						animationResize(game.frame.reels[row].tall.inner);
						break;
					}
					
					else if (game.old.matrix[row][symbol] === 0) {
						game.frame.reels[row].tall.attr('class', 'wild full win quick');
						game.spindle.reels[row].window.tall.attr('class', 'full show');
						game.spindle.reels[row].window.tall.pos = 'full';
						animationResize(game.frame.reels[row].tall);
						animationResize(game.frame.reels[row].tall.inner);
						break;
					}
					
					else {
						game.frame.reels[row].tall.attr('class', '');
					}
				}
			}
		}, 10);
	});
	
	function recoverReplaced() {
		if (!game.last.replaced) {
			return;
		}
		
		for (var row in game.last.replaced) {
			for ( var symbol in game.last.replaced[row]) {
				if (game.last.replaced[row][symbol]) {
					game.spindle.reels[row].window.symbols[symbol].addClass('replaced');
					game.frame.reels[row].symbols[symbol].addClass('replaced');
				}
			}
		}
	}
	
	function setWilds(reelMatrix) {
		if (!reelMatrix) {
			reelMatrix = game.last.matrix;
		}

		for (var row in game.spindle.reels ) {
			var tall = game.spindle.reels[row].window.tall;
			var topSym = (reelMatrix[row][0] === 0);
			var midSym = (reelMatrix[row][1] === 0);
			var botSym = (reelMatrix[row][2] === 0);
			
			tall.attr('class', '');
			
			if (!topSym && !midSym && !botSym) {
				continue;
			}
			
			if (topSym && !midSym && !botSym) {
				tall.attr('class', 'top show');
				tall.pos = 'top';
			}
			
			else if (topSym && midSym && !botSym) {
				tall.attr('class', 'topMid show');
				tall.pos = 'topMid';
			}
			
			else if (!topSym && !midSym && botSym) {
				tall.attr('class', 'bot show');
				tall.pos = 'bot';
			}
			
			else if (!topSym && midSym && botSym) {
				tall.attr('class', 'botMid show');
				tall.pos = 'botMid';
			}
			
			else {
				tall.attr('class', 'full show');
				tall.pos = 'full';
			}
		}
	}
	
	function beginDass() {
		var delay = 0;
		
		if (game.inRecall || game.last.frameFlashing || !game.last.bothComplete) {
			game.last.bothComplete = true;
			return;
		}
		
		game.pays.time = 2000;
		game.last.dassTriggered = true;
		
		if (game.last.enteringFreeSpin) {
			game.panel.setWin(true);
			game.last.doubleRollup = false;
			game.last.enteringFreeSpin = false;
			return;
		}
		
		game.celebration.removeClass('animate');
		game.fire_holder.removeClass('animate');
		
		game.panel.disable('freespin');
		game.pays.clear();
		game.panel.setWin(true);
		game.last.lines.pays = game.last.lines.luckyPays;
		game.last.win = game.last.totalWin;
		
		if (game.feature.active) {
			delay = 2000;
		}
		
		setTimeout(function() {
			game.last.doubleRollup = false;
		}, delay);
		
		if (game.last.lines.scatterPays) {
			game.last.scatters.pays = game.last.lines.scatterPays;
			game.last.bonuses = [];
		}
		
		if (game.last.delayBonuses) {
			game.last.bonuses[0] = game.last.delayBonuses;
			delete game.last.delayBonuses;
		}
		
		frameFlash();
		
		setTimeout(function() {
			luckyShift();
		}, 1000);
	}
	
	function frameFlash() {
		game.last.frameFlashing = true;
		
		for (var row in game.last.replaced) {
			for (var symbol in game.last.replaced) {
				if (game.last.replaced[row][symbol]) {
					game.frame.reels[row].symbols[symbol].addClass('flash');
				}
			}
		}
		
		setTimeout(function() {
			for (var row in game.frame.reels) {
				for (var symbol in game.frame.reels[row].symbols) {
					game.frame.reels[row].symbols[symbol].removeClass('flash');
				}
			}
			
			game.last.frameFlashing = false;
		}, 800);
	}
	
	function wildShift(reel, time) {
		setTimeout(function() {
			game.frame.reels[reel].tall.attr('class', 'wild full');
			animationResize(game.frame.reels[reel].tall);
			animationResize(game.frame.reels[reel].tall.inner);
			
			// if (game.inRecall) {
			game.spindle.reels[reel].window.tall.pos = 'full';
			// }
		}, time);
	}
	
	function luckyShift() {
		var topSym = false;
		var midSym = false;
		var botSym = false;
		var numReelsReplaced = 0;
		
		for (var row in game.last.replaced) {
			for (var symbol in game.last.replaced[row]) {
				if (game.last.replaced[row][symbol]) {
					game.frame.reels[row].symbols[symbol].addClass('shine');
				}
			}
	
			topSym = game.last.replaced[row][0];
			midSym = game.last.replaced[row][1];
			botSym = game.last.replaced[row][2];
			
			if (topSym || midSym || botSym) {
				numReelsReplaced++;
				
				if (topSym && midSym && botSym) {
					game.frame.reels[row].tall.addClass('full');
				}
				
				else if (topSym && midSym) {
					game.frame.reels[row].tall.addClass('topMid');
				}
				
				else if (midSym && botSym) {
					game.frame.reels[row].tall.addClass('botMid');
				}
				
				else if ( topSym ) {
					game.frame.reels[row].tall.addClass('top');
				}
				
				else {
					game.frame.reels[row].tall.addClass('bot');
				}
				
				luckyChange(row, 1000);
			}
			
			else if (game.frame.reels[row].tall.hasClass('wild')) {
				wildShift(row, 1000);
			}
		}
		
		if (!game.feature.active) {
			var enteringFreeSpin = true;
		}
		
		if (game.last && game.last.luckyReplace === 11) {
			game.last.scatters.pays[0][2] = 'Free Spins';
			game.messaging.hide('logo');
			game.features.freespin.play.message.html('PRESS TO START');
			
			setTimeout(function() {
				game.features.freespin.intro.attr('class', ' intro show _' + numReelsReplaced);
				game.sounds.play([ 'freespin', 'smallTrigger' ]);
				
				setTimeout(function() {
					if (enteringFreeSpin && !game.last.recovered) {
						game.last.doubleRollup = true;
						game.last.enteringFreeSpin = true;
						
						if (!game.inRecall && game.old) {
							game.panel.setWin(game.old.win);
						}
					}
					
					game.features.freespin.intro.removeClass('show');
					
					for (var row in game.frame.reels) {
						if (game.frame.reels[row].tall.hasClass('scatterRepeat')) {
							game.frame.reels[row].tall.addClass('animate');
							animationResize(game.frame.reels[row].tall);
							animationResize(game.frame.reels[row].tall.inner);
						}
					}
				}, 4500);
			}, 6000);
		}
		
		for (var level in game.panel.bigwin.levels) {
			clearTimeout(game.panel.bigwin.levels[level].timer);
		}
		
		setTimeout(function() {
			if (game.last.luckyReplace !== 11 && !game.feature.active) {
				game.panel.enable();
			}
			
			if (!game.inRecall && game.last.baseWin !== game.last.totalWin) {
				spinDone();
			}
			
			if (game.last.baseWin === game.last.totalWin) {
				if (!game.feature.active) {
					game.messaging.show('logo');
					game.trigger('round_complete');
				}
				
				else if (game.last.spins !== undefined && game.last.spins !== 0) {
					game.trigger('round_complete');
				}
			}
		}, 3250);
	}
	
	function luckyChange(reel, time) {
		game.frame.reels[reel].tall.removeClass('quick');
		game.frame.reels[reel].tall.addClass('lucky');
		
		setTimeout(function() {
			game.frame.reels[reel].tall.attr('class', 'lucky show full');
			animationResize(game.frame.reels[reel].tall);
			animationResize(game.frame.reels[reel].tall.inner);
			game.sounds.play('latch');
			game.sounds.play('reveal');
			
			setTimeout(function() {
				if (game.last.luckyReplace !== 0 && game.last.luckyReplace !== 11) {
					game.spindle.reels[reel].window.symbols[0].attr('class', 'symbol symbol-' + game.last.luckyReplace + ' replaced hide');
					game.spindle.reels[reel].window.symbols[1].attr('class', 'symbol symbol-' + game.last.luckyReplace + ' replaced hide');
					game.spindle.reels[reel].window.symbols[2].attr('class', 'symbol symbol-' + game.last.luckyReplace + ' replaced hide');
					
					game.frame.reels[reel].symbols[0].attr('class', 'symbol symbol-' + game.last.luckyReplace + ' replaced');
					game.frame.reels[reel].symbols[1].attr('class', 'symbol symbol-' + game.last.luckyReplace + ' replaced');
					game.frame.reels[reel].symbols[2].attr('class', 'symbol symbol-' + game.last.luckyReplace + ' replaced');
					
					game.frame.reels[reel].tall.attr('class', '');
				}
				
				else if (game.last.luckyReplace === 0) {
					game.frame.reels[reel].tall.attr('class', 'wildFrame full');
					animationResize(game.frame.reels[reel].tall);
					animationResize(game.frame.reels[reel].tall.inner);
				}
				
				else {
					game.frame.reels[reel].tall.attr('class', 'scatter full');
					animationResize(game.frame.reels[reel].tall);
					animationResize(game.frame.reels[reel].tall.inner);
					scatterTiming(reel);
				}
			}, 1000);
		}, time);
	}
	
	function scatterTiming(reel) {
		var timer = 1000;
		var numScatter = 0;
		
		for (var row = 0; row < reel; row++) {
			for (var symbol in game.last.replaced[row]) {
				if (game.last.replaced[row][symbol]) {
					timer += 300;
					numScatter++;
					break;
				}
			}
		}
		
		setTimeout(function() {
			game.frame.reels[reel].tall.addClass('flash');
			
			if (!game.sounds.fallback) {
				game.sounds.play([ 'drop', '11', numScatter ]);
			}
			
			setTimeout(function() {
				game.frame.reels[reel].tall.attr('class', 'scatterRepeat full');
				animationResize(game.frame.reels[reel].tall);
				animationResize(game.frame.reels[reel].tall.inner);
			}, 1500);
		}, timer);
	}
	
	game.on('recall_action', function(config) {
		setTimeout(function() {
			if (config.detail) {
				config = config.detail;
			}
			
			this.spindle.attr('class', 's' + this.last.replace);
			
			if (this.last.replaced) {
				for (var col = 0; col < this.frame.reels.length; col++) {
					for (var row = 0; row < this.frame.reels[col].symbols.length; row++) {
						if (this.last.replaced[col][row]) {
							this.frame.reels[col].symbols[row].addClass('replaced');
							this.spindle.reels[col].window.symbols[row].addClass('replaced');
						}
					}
				}
			}
		}.bind(this), 2);
	});
	
	// recover cost
	game.on('ui', function() {
		if (!game.last._cost) {
			setTimeout(function() {
				var bet = game.panel.getBet();
				game.last._cost = bet.coins * bet.lines;
			}, 1);
		}
		
		game.features.freespin.intro = $.div().addClass('intro').appendTo(game.container);
		game.features.freespin.intro.nums = [];
		game.features.freespin.intro.nums[0] = $.div().addClass('digit2').appendTo(game.features.freespin.intro);
		game.features.freespin.intro.nums[1] = $.div().addClass('digit1').appendTo(game.features.freespin.intro);
		
		for (var row in game.frame.reels) {
			game.spindle.reels[row].window.tall =  $.div('tall').appendTo(game.spindle.reels[row].window);
			game.frame.reels[row].tall = $.div('tall').appendTo(game.frame.reels[row]);
			game.frame.reels[row].tall.inner = $.div().appendTo(game.frame.reels[row].tall);
			animationResize(game.frame.reels[row].tall);
			animationResize(game.frame.reels[row].tall.inner);
		}
	});
	
	game.panel.disableBigWins = function(durations) {
		this.bigwin.celebrations = {};
		
		for (var i = 0; i < this.bigwin.levels.length; i++) {
			this.bigwin.levels[i] = [ this.bigwin.levels[i][this.bigwin.levels[i].length - 1] ];
			
			if ( this.bigwin.levels[i][0].duration ) {
				this.bigwin.levels[i][0].duration = undefined;
				delete this.bigwin.levels[i][0].duration;
			}
			
			if (durations && durations[i]) {
				this.bigwin.levels[i][0].duration = durations[i];
			}
			
			if ( this.bigwin.levels[i][0].celebration ) {
				this.bigwin.levels[i][0].celebration = undefined;
				delete this.bigwin.levels[i][0].celebration;
			}
		}
	};
	
	game.panel.disableBigWins([ 1, 2, 3, 5, 12, 15 ]);
	
	function decideFireworks() {
		var decide = 0;
		var factor = 5;
		var winFactor = 0;
		var win = game.last.win;
		
		if (game.last._cost) {
			winFactor = win / (game.last._cost);
		}
		else if (game.old && game.old._cost) {
			winFactor = win / (game.old._cost);
		}
		else if (game.old && game.old._cost === 0) {
			winFactor = win / ((game.panel.lines.get()) * game.panel.coins.get());
		}
		
		for (decide = 0; decide < game.panel.bigwin.breakpoints.length; decide++) {
			if (winFactor < game.panel.bigwin.breakpoints[decide]) {
				break;
			}
		}

		if (decide >= factor) {
			game.fire_holder.addClass('animate');
			game.celebration.addClass('animate');
		}
	}

	if(window.handHeldCheck()) {
		let spindleScalar = 4;

		game.addClass("handHeld");

		if (game.panel.type === 'mobile') {
			spindleScalar = 2;
		}

		function resizeSpindleContainer(widthMult, heightMult) {
			game.spindle.container.css({
				width:  (game.container.el.clientWidth * widthMult) / spindleScalar + 'px',
				height:  (game.container.el.clientHeight * heightMult) / spindleScalar + 'px'
			});
		}

		game.on('ui', function() {
			let containerHeightRatio = game.spindle.container.el.clientHeight / game.container.el.clientHeight;
			let containerWidthRatio = game.spindle.container.el.clientWidth / game.container.el.clientWidth;

			if(game.panel.type === "mobile") {
				game.addClass("mobile");
			}

			resizeSpindleContainer(containerWidthRatio, containerHeightRatio);

			game.on('scale', function() {
				resizeSpindleContainer(containerWidthRatio, containerHeightRatio);
			});
		});
	}
});



/** WEBPACK FOOTER **
 ** ./public-src/js/primary.js
 **/